import VueI18n from 'vue-i18n';
import Vue from 'vue';
import * as moment from "moment";
moment.locale(localStorage.getItem("lang"));
Vue.use(VueI18n);

const i18n: VueI18n = new VueI18n({
  fallbackLocale: 'fr',
  messages: {
    fr: {
      ...require('./button/button.fr.json'),
      ...require('./generic-labels/generic-labels.fr.json'),
      ...require('./validation-messages/validation-messages.fr.json'),
      ...require('./login-form/login-form.fr.json'),
      ...require('./agenda/agenda.fr.json'),
      ...require('./ticket/ticket.fr.json'),
      ...require('./block/block.fr.json'),
      ...require('./apartment/apartment.fr.json'),
      ...require('./dashboard/dashboard.fr.json'),
      ...require('./contact/contact.fr.json'),
      ...require('./settings-admin/settings-admin.fr.json'),
      ...require('./profile/profile.fr.json'),
      ...require('./reception/reception.fr.json'),
      ...require('./user/user.fr.json'),
      ...require('./document/document.fr.json'),
      ...require('./building-monitor/building-monitor.fr.json'),
      ...require('./equipment/equipment.fr.json'),
      ...require('./agency-management/am.fr.json'),
      ...require('./maintenance/am.fr.json'),
      ...require('./service-book/sb.fr.json'),
    },
    en: {
      ...require('./button/button.en.json'),
      ...require('./generic-labels/generic-labels.en.json'),
      ...require('./validation-messages/validation-messages.en.json'),
      ...require('./login-form/login-form.en.json'),
      ...require('./agenda/agenda.en.json'),
      ...require('./ticket/ticket.en.json'),
      ...require('./block/block.en.json'),
      ...require('./apartment/apartment.en.json'),
      ...require('./dashboard/dashboard.en.json'),
      ...require('./contact/contact.en.json'),
      ...require('./settings-admin/settings-admin.en.json'),
      ...require('./profile/profile.en.json'),
      ...require('./reception/reception.en.json'),
      ...require('./user/user.en.json'),
      ...require('./document/document.en.json'),
      ...require('./building-monitor/building-monitor.en.json'),
      ...require('./equipment/equipment.en.json'),
      ...require('./agency-management/am.en.json'),
      ...require('./maintenance/am.en.json'),
      ...require('./service-book/sb.en.json'),
    }
  }
});

export default i18n;



// WEBPACK FOOTER //
// ./src/locales/index.ts